import type { AxiosResponse } from 'axios'

import releaseNotesQueries from '@/api/modules/releaseNotesQueries'
import type { ReleaseNoteVersionResponseSchema } from '@/api/schemas/releaseNotes/releaseNotes'
import { t } from '@/i18n'
import { handleApiError } from '@/utils/apiHelpers'

class ReleaseNotesService {
    async fetchLatestVersion(): Promise<AxiosResponse<ReleaseNoteVersionResponseSchema>> {
        try {
            return await releaseNotesQueries.fetchLatestVersion()
        } catch (error) {
            handleApiError(error, t('common.releaseNotes.errors.fetchLatestVersion'))
            throw error
        }
    }
}

export const releaseNotesService = new ReleaseNotesService()
